function bindBespokeGalleryPopup() {
    const popup = document.getElementById('rolex-slider-popup');
    const closeBtn = document.getElementById('rolex-close-slider-button');
    const thumbImages = document.querySelectorAll('#rolex-bespoke-gallery-thumbs .splide__slide img');

    let popupSlider = null;
    let isSliderInitialized = false;

    // Initialize popup slider only once
    function initializePopupSlider() {
        if (!isSliderInitialized) {
            // Destroy any existing slider first
            const existingSlider = document.querySelector('#rolex-bespoke-gallery .splide__pagination');
            if (existingSlider) {
                existingSlider.remove();
            }

            popupSlider = new Splide('#rolex-bespoke-gallery', {
                type: 'slide',
                perPage: 1,
                pagination: true,
                arrows: true,
                classes: {
                    pagination: 'splide__pagination custom-pagination',
                    page: 'splide__pagination__page custom-page'
                }
            }).mount();
            
            isSliderInitialized = true;
        }
    }

    // Add click event to each thumbnail image
    thumbImages.forEach((img, index) => {
        img.addEventListener('click', function () {
            // Show popup
            popup.style.display = 'grid';
            
            // Initialize slider if not already done
            initializePopupSlider();
            
            // Navigate to the clicked image index
            if (popupSlider) {
                popupSlider.go(index);
            }
        });
    });

    closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
    });
}

function initializeMobileThumbsSlider() {
    const mobileThumbs = document.getElementById('rolex-bespoke-mobile-thumbs');
    if (!mobileThumbs || mobileThumbs.classList.contains('splide-initialized')) {
        return;
    }
    const existingPagination = mobileThumbs.querySelector('.splide__pagination');
    if (existingPagination) {
        existingPagination.remove();
    }
    
    // Clean up any existing arrows
    const existingArrows = mobileThumbs.querySelectorAll('.splide__arrow');
    existingArrows.forEach(arrow => arrow.remove());
    
    try {
        const mobileSlider = new Splide('#rolex-bespoke-mobile-thumbs', {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: true,
            arrows: true,
            classes: {
                pagination: 'splide__pagination mobile-pagination',
                page: 'splide__pagination__page mobile-page'
            },
            breakpoints: {
                1023: { perPage: 1 },
                767: { perPage: 1 },
            },
        }).mount();
        
        // Mark as initialized to prevent re-initialization
        mobileThumbs.classList.add('splide-initialized');
        
        // Store reference for potential cleanup
        mobileThumbs._splideInstance = mobileSlider;
        
    } catch (error) {
        console.error('Error initializing mobile thumbs slider:', error);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    bindBespokeGalleryPopup(); // existing functionality
    initializeMobileThumbsSlider(); // new mobile thumbs gallery
});
